import { useQuery } from "@tanstack/react-query";
import { EuRelabelCheckInService } from "src/services";
import { queryKeys } from "src/constants";

export const useTransferOrderEuRelabelCheckIns = (
  transferOrderId: string,
  euRelabelCheckInService: EuRelabelCheckInService
) => {
  const {
    data: euRelabelCheckIns,
    error: fetchError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: queryKeys.transferOrderEuRelabelCheckIns(transferOrderId),
    queryFn: async () => await euRelabelCheckInService.getAllByTransferOrderId(transferOrderId),
    enabled: !!transferOrderId,
    retry: false
  });

  return { euRelabelCheckIns, fetchError, isLoading, refetch };
};
